import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setSignatures } from '../store/signatures.actions'

export function* getSignatures(pcrDoc: IPcr) {
  const signatures = pcrDoc.signatures
  if (signatures && Object.keys(signatures).length !== 0) {
    yield put(setSignatures(signatures))
  }
}
